function getOpt(dataObj, colorList) {
  let xData = dataObj.xData;
  let yData = dataObj.yData;
  let unit = dataObj.unit;
  let key = dataObj.key;
  let aa = null;
  if (key == "COD") {
    aa = 30;
  } else if (key == "氨氮") {
    aa = 5;
  } else if (key == "总氮") {
    aa = 10;
  } else if (key == "总磷") {
    aa = 0.5;
  } else {
    aa = NaN;
  }
  return {
    backgroundColor: "transparent",
    tooltip: {
      trigger: "axis",
      backgroundColor: "rgba(0, 0, 0, 0.79)",
      axisPointer: {
        lineStyle: {
          color: "#57617B",
        },
      },
      borderWidth: 0,
      textStyle: {
        // color: colorList//设置文字颜色
        color: "rgba(255, 255, 255, 1)",
      },
      formatter: function (params) {
        if (key == "PH值" && params[0].value) {
          return params[0].axisValue + "<br/>" + key + " : " + params[0].value;
        } else if (params[0].value) {
          return (
            params[0].axisValue + "<br/>" + key + " : " + params[0].value + unit
          );
        }
      },
    },
    legend: {
      icon: "rect",
      itemWidth: 14,
      itemHeight: 5,
      itemGap: 13,
      right: "4%",
      textStyle: {
        fontSize: 20,
        color: "#fff",
      },
    },
    grid: {
      top: "15%",
      left: "6%",
      right: "6%",
      bottom: "0%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: true,
        axisLine: {
          lineStyle: {
            color: "rgb(48, 95, 115)",
          },
        },
        axisLabel: {
          //坐标轴刻度标签的相关设置
          textStyle: {
            color: "#CBCBCB",
            fontSize: 14,
          },
        },
        axisTick: {
          show: false,
        },
        data: xData,
      },
    ],
    yAxis: {
      type: "value",
      name: key + "(" + unit + ")",
      nameTextStyle: {
        color: "rgb(255, 255, 255)",
        fontSize: 12,
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        lineStyle: {
          color: "rgb(48, 95, 115)",
        },
      },
      axisLabel: {
        margin: 10,
        textStyle: {
          color: "#CBCBCB",
          fontSize: 14,
        },
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: "rgba(48, 95, 115,.3)",
        },
      },
    },
    series: {
      // name: '厂区',
      type: "line",
      smooth: false,
      symbol: "circle",
      symbolSize: 5,
      showSymbol: false,
      connectNulls: true,
      lineStyle: {
        normal: {
          width: 3,
          // color: "rgba(62, 234, 236, 1)"//线的颜色
          color: colorList,
        },
      },
      // areaStyle: {
      //   normal: {
      //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      //       offset: 0,
      //       color: 'rgba(62, 234, 236, 0.2)'
      //     }, {
      //       offset: 0.8,
      //       color: 'rgba(62, 234, 236, 0.05)'
      //     }], false),
      //     shadowColor: 'rgba(62, 234, 236, 0)',
      //     shadowBlur: 10
      //   }
      // },
      itemStyle: {
        normal: {
          color: colorList,
        },
      },
      data: yData,
      markLine: {
        symbol: "none",
        data: [
          {
            type: "average",
            yAxis: aa, //警戒线在y轴的坐标
          },
        ],
        silent: true,
        precision: 1,
        label: {
          show: true,
          padding: [-13, -20, 15, -75], // 重点在这里，这个地方就是定位
          position: "end",
          formatter: "超低限值线",
        },
      },
    },
  };
}

export default getOpt;
